import { Component } from '@angular/core';
import { MatFormField, MatLabel, MatSuffix } from '@angular/material/form-field';
import { MatInput } from '@angular/material/input';
import { MatIcon } from '@angular/material/icon';
import { MatSelect } from '@angular/material/select';
import { ReactiveFormsModule } from '@angular/forms';
import { MatOption } from '@angular/material/autocomplete';
import { MatRadioGroup, MatRadioButton } from '@angular/material/radio';
import { MatCheckbox } from '@angular/material/checkbox';

@Component({
    selector: 'app-genric-fields',
    templateUrl: './genric-fields.component.html',
    styleUrls: ['./genric-fields.component.scss'],
    imports: [MatFormField, MatLabel, MatInput, MatIcon, MatSuffix, MatSelect, ReactiveFormsModule, MatOption, MatRadioGroup, MatRadioButton, MatCheckbox]
})
export class GenricFieldsComponent {

}
